import React, { useMemo } from 'react';

import { transformMedicationOptions } from '../../utils/transformMedicationOptions';
import { ManufacturerCardEditConditionalContainerProps } from '../../types/ManufacturerCardEditConditionalContainerProps';
import { ELEMENT_IDS } from '../../../../utils/element-ids';

import LegacyManufacturerCardWarning from './LegacyManufacturerCardWarning';
import ManufacturerCardCheckbox from './ManufacturerCardCheckbox';
import MedicationSelectorDropdown from './MedicationSelectorDropdown';

export const ManufacturerCardEditConditionalContainer = ({
  isLegacyManufacturerCard,
  manufacturerCardCheckboxProps,
  medicationSelectorDropdownProps,
}: ManufacturerCardEditConditionalContainerProps) => {
  const transformedMedicationOptions = useMemo(
    () =>
      transformMedicationOptions(
        medicationSelectorDropdownProps.options,
      ),
    [medicationSelectorDropdownProps.options],
  );
  return (
    <>
      {isLegacyManufacturerCard ? (
        <LegacyManufacturerCardWarning
          id={ELEMENT_IDS.LEGACY_MANUFACTURER_CARD_WARNING}
        />
      ) : (
        <ManufacturerCardCheckbox
          {...manufacturerCardCheckboxProps}
        />
      )}

      {manufacturerCardCheckboxProps.value ? (
        <MedicationSelectorDropdown
          {...medicationSelectorDropdownProps}
          options={transformedMedicationOptions}
        />
      ) : null}
    </>
  );
};
